import React from 'react';

const SensorKualitasAirCerdas: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Akses terhadap air bersih merupakan salah satu pilar utama dalam Tujuan Pembangunan Berkelanjutan (SDGs). Di banyak wilayah perairan sungai dan danau di Indonesia, pencemaran limbah cair domestik dan industri sering kali baru terdeteksi setelah timbul dampak fatal terhadap ekosistem ikan dan kesehatan masyarakat sekitar.
      </p>

      <p className="mb-4">
        Menjawab tantangan tersebut, peserta kategori <b>Innovative Technology Challenge (ITC)</b> merancang <b>Buoy Monitoring Kualitas Air Cerdas</b> berbasis mikrokontroler hemat energi dan jaringan sensor Internet of Things (IoT) yang mampu mengapung dan beroperasi secara mandiri di aliran sungai.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Sensor Multi-Parameter yang Terintegrasi
      </h2>
      <ul className="list-disc pl-6 mb-6 space-y-3">
        <li>
          <strong>Sensor Kekeruhan (Turbidity Sensor):</strong> Mengukur kadar partikel tersuspensi dalam air menggunakan prinsip dispersi cahaya optik.
        </li>
        <li>
          <strong>Sensor Derajat Keasaman (pH Sensor):</strong> Mendeteksi anomali keasaman air akibat limbah kimia berbahaya secara real-time.
        </li>
        <li>
          <strong>Sensor Dissolved Oxygen (DO):</strong> Memantau kadar oksigen terlarut yang sangat vital bagi kelangsungan hidup biota air sungai.
        </li>
        <li>
          <strong>Sensor Total Dissolved Solids (TDS):</strong> Mengukur konsentrasi senyawa anorganik terlarut dalam air.
        </li>
      </ul>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Transmisi Data Jarak Jauh Berdaya Surya
      </h2>
      <p className="mb-4">
        Perangkat pelampung cerdas ini ditenagai oleh panel surya mini 5V yang mengisi baterai lithium 18650 secara otomatis. Data telemetri dikirimkan setiap 15 menit melalui modul nirkabel LoRaWAN ke stasiun pemantau pusat tanpa bergantung pada ketersediaan sinyal seluler 4G.
      </p>

      <p className="mb-4">
        Inovasi alat pemantau air mandiri ini menjadi bukti nyata bagaimana kecerdasan rekayasa pelajar muda dapat menghadirkan solusi konkret bagi pelestarian lingkungan air tanah air.
      </p>
    </div>
  );
};

export default SensorKualitasAirCerdas;
